import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import frFR from 'antd/lib/locale/fr_FR';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Router from '../components/Router';
import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary';

import './styles.less';

const GetAntLocale = (localeString) => {
  if (localeString.includes('fr')) {
    return frFR;
  }

  return enUS;
};

const Content = ({ children }) => <div className="app-content">{children}</div>;

Content.propTypes = {
  children: PropTypes.node.isRequired,
};

const App = () => {
  const { i18n } = useTranslation();

  return (
    <ErrorBoundary>
      <ConfigProvider locale={GetAntLocale(i18n.language)}>
        <BrowserRouter>
          <Content>
            <Router />
          </Content>
        </BrowserRouter>
      </ConfigProvider>
    </ErrorBoundary>
  );
};

export default App;
